(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightPunctuality.controller:DelayCodesModalCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('flightPunctuality')
		.controller('crewDetailsPopupCtrl', crewDetailsPopupCtrl);

	function crewDetailsPopupCtrl($uibModalInstance, modalParams , FlightPunctualityService) {
		var vm = this;

		vm.model = {
      flightLeg: modalParams.flightLeg,
      joiningCrewList:[]
		};

		vm.closeMe = function() {
			$uibModalInstance.close();
		};

    (function loadJoiningCrewDetails() {
      FlightPunctualityService.getJoininigCrews(vm.model.flightLeg.FLI, function (joinngCrewListRS) {
        vm.model.joiningCrewList = joinngCrewListRS.flightJoiningCrewList;
      }, function () {
        console.log('Error retrieving joining Crew deatils');
      });
    })();
	}
}());
